module.exports = __webpack_public_path__ + "static/media/VisitNotesPdf.04e15052.txt";